const normalizeUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `https://${url}`;
};

const extractYouTubeVideoId = (url) => {
  if (!url) return null;

  try {
    const parsed = new URL(normalizeUrl(url));
    const hostname = parsed.hostname.replace('m.', '');

    if (hostname === 'youtu.be') {
      return parsed.pathname.split('/')[1] || null;
    }

    if (!hostname.includes('youtube.com')) {
      return null;
    }

    const searchId = parsed.searchParams.get('v');
    if (searchId) {
      return searchId;
    }

    const segments = parsed.pathname.split('/').filter(Boolean);
    if (segments.length === 0) {
      return null;
    }

    const mapping = ['embed', 'shorts', 'live'];
    if (mapping.includes(segments[0])) {
      return segments[1] || null;
    }

    // Fallback for /v/VIDEOID or any other path where the ID is second segment
    if (segments.length > 1) {
      return segments[1];
    }
  } catch (error) {
    console.warn('Failed to parse video url', url, error);
  }

  return null;
};

export const convertToEmbedUrl = (url) => {
  if (!url) return url;

  const videoId = extractYouTubeVideoId(url);
  if (videoId) {
    return `https://www.youtube.com/embed/${videoId}?rel=0&playsinline=1&autoplay=1&mute=1&loop=1&playlist=${videoId}`;
  }

  if (url.includes('/embed/')) {
    return url;
  }

  return url;
};

export const isYouTubeUrl = (url) => {
  if (!url) return false;
  const normalized = normalizeUrl(url);
  return normalized.includes('youtube.com') || normalized.includes('youtu.be');
};

export const getVideoId = (url) => extractYouTubeVideoId(url);
